import { ActionMenu, ActionMenuItem, ActionMenuTrigger, Button } from '@ekhodealer/ekho-common/rev';

import type { LeadsTableRow } from '@ekhodealer/ekho-common';

import { Checkmark24, ChevronDown12 } from '@common/components/icons';

import { useStageSelection } from '../hooks/useStageSelection';

import { StageTag } from './StageTag';

export interface StageActionMenuProps {
	item: LeadsTableRow;
}

export const StageActionMenu = ({ item }: StageActionMenuProps) => {
	const { stageOptions, currentStageType, handleStageSelect } = useStageSelection({
		item,
		stageReason: 'Updated from table',
	});

	return (
		<ActionMenuTrigger>
			<Button
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'
				aria-label={`Change stage for ${item.name}`}>
				<StageTag stage={item.stage} />
			</Button>
			<ActionMenu>
				{stageOptions.map((stageConfig) => {
					const isCurrentStage = stageConfig.stage === currentStageType;
					return (
						<ActionMenuItem
							key={stageConfig.stage}
							label={
								<StageTag
									stage={{ type: stageConfig.stage, name: stageConfig.name }}
								/>
							}
							trailingAccessory={isCurrentStage ? <Checkmark24 /> : undefined}
							onAction={() => handleStageSelect(stageConfig.stage)}
						/>
					);
				})}
			</ActionMenu>
		</ActionMenuTrigger>
	);
};
